import type { ChangeEvent, DetailedHTMLProps, FC, ForwardedRef, TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

export type TextAreaProps = {
  errorMsg?: string;
  wrapperClassName?: string;
  maxLength?: number | null | undefined;
  value?: string | readonly string[];
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
} & DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;

const TextAreaComp = (
  { errorMsg, wrapperClassName, value, className, onChange, maxLength, ...props }: TextAreaProps,
  ref: ForwardedRef<HTMLTextAreaElement>
) => {
  if (maxLength === undefined) {
    maxLength = 200;
  }

  return (
    <div className={twMerge('relative', wrapperClassName)}>
      <textarea
        ref={ref}
        onChange={(event) => {
          onChange(event);
        }}
        className={twMerge(
          'flex min-h-[96px] border-primary-border bg-primary-background text-primary-900 placeholder:text-other-textPlaceholder w-full h-fit rounded-lg align-top px-3.5 py-3',
          'focus:shadow-none focus:outline-none focus:ring-2 focus:ring-brand-600 focus:ring-offset-2',
          'disabled:cursor-not-allowed disabled:text-primary-900/25 ',
          errorMsg ? 'border-error' : '',
          className
        )}
        value={value}
        {...props}
        {...(maxLength && { maxLength })}
      />
      {errorMsg ? (
        <p role='alert' className='text-red-500'>
          {errorMsg}
        </p>
      ) : null}
    </div>
  );
};

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(TextAreaComp) as FC<TextAreaProps>;
